import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import LogoAnimation from "../components/LogoAnimation";
import BookingSection from "../components/BookingSection";
import StickyMobileCTA from "../components/StickyMobileCTA";
import TestimonialsSection from "../components/TestimonialsSection";
import { NavHeader } from "../components/sections/NavHeader";
import { HeroSection } from "../components/sections/HeroSection";
import { WhatIsCryotherapySection } from "../components/sections/WhatIsCryotherapySection";
import { ClinicalStudiesSection } from "../components/sections/ClinicalStudiesSection";
import { PainReliefSection } from "../components/sections/PainReliefSection";
import { FatReductionSection } from "../components/sections/FatReductionSection";
import { GymPartnershipsSection } from "../components/sections/GymPartnershipsSection";
import { ChiroPTSection } from "../components/sections/ChiroPTSection";
import { SportsTeamsSection } from "../components/sections/SportsTeamsSection";
import { RacesTrackSection } from "../components/sections/RacesTrackSection";
import { BaseballSection } from "../components/sections/BaseballSection";
import { CorporateWellnessSection } from "../components/sections/CorporateWellnessSection";
import { MeetOwnerSection } from "../components/sections/MeetOwnerSection";
import { TrustSection } from "../components/sections/TrustSection";
import { FinalCTASection } from "../components/sections/FinalCTASection";
import { SiteFooter } from "../components/sections/SiteFooter";

const HASH_SCROLL_DELAY_MS = 100;

const Home = () => {
  const [showAnimation, setShowAnimation] = useState(true);
  const location = useLocation();

  // Handle hash-based scrolling (from sub-pages linking to /#section-id)
  useEffect(() => {
    if (location.hash && !showAnimation) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, HASH_SCROLL_DELAY_MS);
    }
  }, [location.hash, showAnimation]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {showAnimation && <LogoAnimation onComplete={() => setShowAnimation(false)} />}

      <div className={`min-h-screen bg-[#0a0318] ${showAnimation ? "hidden" : ""}`} data-testid="home-page">
        <NavHeader scrollToSection={scrollToSection} />
        <HeroSection scrollToSection={scrollToSection} />
        <WhatIsCryotherapySection />
        <ClinicalStudiesSection />
        <PainReliefSection scrollToSection={scrollToSection} />
        <FatReductionSection scrollToSection={scrollToSection} />
        <GymPartnershipsSection scrollToSection={scrollToSection} />
        <ChiroPTSection scrollToSection={scrollToSection} />
        <SportsTeamsSection scrollToSection={scrollToSection} />
        <RacesTrackSection scrollToSection={scrollToSection} />
        <BaseballSection scrollToSection={scrollToSection} />
        <CorporateWellnessSection scrollToSection={scrollToSection} />
        <MeetOwnerSection />
        <TestimonialsSection />
        <TrustSection />
        <FinalCTASection scrollToSection={scrollToSection} />
        <BookingSection />
        <SiteFooter scrollToSection={scrollToSection} />
        <StickyMobileCTA scrollToSection={scrollToSection} />
      </div>
    </>
  );
};

export default Home;

